import AbstractRequestTask from './AbstractRequestTask';
import Utils from '../../utils/Utils';
import htmlDecode from '../../utils/htmlDecode';
import { converter } from '../../helpers/converter';

class PaywayConfirmTask extends AbstractRequestTask {
  constructor(url, params = {}, translations, headers) {
    super();
    this.url = url;
    this.params = params;
    this.isConfirm = this.url.indexOf('services/payway/confirm');
    this.isUpsell = this.url.indexOf('services/payway/upsell');
    this.isDownsell = this.url.indexOf('services/payway/downsell');
    this.isBuyConfirm = this.url.indexOf('services/payway/buyconfirm');
    this.userData = JSON.parse(
      localStorage.getItem('loginInfo.logged_user_data'),
    );
    this.translations = translations;
    this.headers = headers;
  }

  getUrl() {
    const urlMfwk = window.getConfig.url_dominio_microfwk;

    // parámetros enviados por GET
    if (this.isUpsell !== -1 || this.isDownsell !== -1) {
      this.getParameter = Object.assign(super.getParams(), {
        object_type: 'A',
      });
      delete this.getParameter.api_version;
      this.newUrl = `${this.url}&${Utils.buildQueryStringParams(
        this.getParameter,
      )}`;
      return urlMfwk + this.newUrl;
    }

    // parámetros enviados por GET
    if (this.isBuyConfirm !== -1) {
      this.getParameter = {
        authpn: window.getConfig.authpn,
        authpt: window.getConfig.authpt,
        format: 'json',
      };
      this.newUrl = `${this.url}&${Utils.buildQueryStringParams(
        this.getParameter,
      )}`;
      return urlMfwk + this.newUrl;
    }

    return urlMfwk + this.url;
  }

  parseErrors(completeError) {
    let message;
    const { translations } = window.utils.getMeta;
    if (this.isBuyConfirm === -1) {
      const error = super.parseErrors(completeError);
      if (
        completeError.errors &&
        Array.isArray(completeError.errors) &&
        completeError.errors[0].code &&
        typeof translations === 'function'
      ) {
        message = translations(
          completeError.errors[0].code,
          completeError.errors[0].code,
        );
      } else if (error.message && typeof translations === 'function') {
        message = translations(error.message, error.message);
      }
    } else {
      if (
        completeError.errors &&
        Array.isArray(completeError.errors) &&
        completeError.errors[0].code &&
        typeof translations === 'function'
      ) {
        message = translations(
          completeError.errors[0].code,
          completeError.errors[0].code,
        );
      } else {
        message = null;
      }
      try {
        message = htmlDecode(message);
      } catch (e) {}
    }
    return { message, completeError };
  }

  getParams() {
    const params = super.getParams();

    // parámetros enviados por POST
    if (this.isDownsell !== -1) {
      return this.params;
    }

    // parámetros enviados por POST
    if (this.isUpsell !== -1) {
      this.params.token = this.userData.token;
      return this.params;
    }

    // parámetros enviados por POST
    if (this.isBuyConfirm !== -1) {
      this.params = Object.assign({}, this.params, {
        token: this.userData.token,
      });
      return this.params;
    }

    // parámetros enviados por GET
    this.params = Object.assign(params, this.params);
    return this.params;
  }

  success(data, b) {
    const isValid = super.success(data, b);
    if (!isValid) {
      const newdata = super.parseErrors(data);
      return this.reject(newdata, b);
    }
    this.resolve(data);
  }

  getMethod() {
    if (this.url && this.isConfirm !== -1) {
      return 'GET';
    }
    return 'POST';
  }

  // getHeaders() {
  //   return {
  //     Authorization: this.headers.authorization,
  //   };
  // }
}

export default PaywayConfirmTask;
